/**
 *  ・定義ファイル役割
 *    共通データベース定義
 *  ・概要
 *    サービス種別で参照するデータベース名を定義
 *  ・更新履歴
 *    2022/06/10 新規作成
 */

export const DSNames: {[screenStructureType: string]: {[id: string]: string}} = {
  // F-Japan
  2: {
    PROJECT_SERVICE: '案件サービス別F-Japan',
    ESTIMATE_BASIC_INFOMATION: '見積基本情報F-Japan',
  },
}